// featureFlags should come from getSessionData in @confluence/session-data
// IMPORTANT: If you change the code below, please also update the
// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
export function getMediaFeatureFlags(featureFlags: { [key: string]: any }):
	| {
			mediaInline: boolean;
	  }
	| {
			mediaInline?: undefined;
	  } {
	return featureFlags
		? {
				mediaInline: true,
			}
		: {};
}
